const DEFAULT_TITLES = {
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Notice",
};

function pushToast(vm, type, desc, title, timeout) {
    const legacyTitles = ["Great!", "Oops!", "Hey"];
    let message = desc || "";
    let toastTitle = "";

    if (title && !legacyTitles.includes(title)) {
        if (message && message !== title) {
            if (title.length >= message.length) {
                message = title;
                toastTitle = message.length <= 28 ? desc : "";
            } else {
                toastTitle = title;
            }
        } else {
            message = title;
        }
    } else if (!message && title) {
        message = title;
    }

    if (vm.$store) {
        vm.$store.commit("showToast", {
            type,
            message,
            title: toastTitle,
            timeout: timeout !== undefined ? timeout : 4000,
        });
    }
}

export default {
    methods: {
        baseurl() {
            return window.hostname;
        },
        toast(desc, title, type = "info", timeout) {
            pushToast(this, type, desc, title, timeout);
        },
        i(desc, title = "Hey") {
            pushToast(this, "info", desc, title);
            if (this.$Notice) {
                this.$Notice.info({ title, desc });
            }
        },
        s(desc, title = "Great!") {
            pushToast(this, "success", desc, title);
            if (this.$Notice) {
                this.$Notice.success({ title, desc });
            }
        },
        w(desc, title = "Oops!") {
            pushToast(this, "warning", desc, title);
            if (this.$Notice) {
                this.$Notice.warning({ title, desc });
            }
        },
        e(desc, title = "Oops!") {
            pushToast(this, "error", desc, title);
            if (this.$Notice) {
                this.$Notice.error({ title, desc });
            }
        },
        swr(desc = "Something went wrong! Please try again.", title = "Oops") {
            pushToast(this, "error", desc, title);
            if (this.$Notice) {
                this.$Notice.error({ title, desc });
            }
        },
    },
};
